import { db$ } from 'nike-re-framejs';
import { useMemo } from 'react';

import { fireGAEvent } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { navigate } from '@/routing';
import { TICKET_DETAIL, TICKET_DETAIL_ALIAS } from '@/routing/routes';

function useTicketDetail() {
    return useMemo(() => {
        return ({ hash, alias }) => {
            const currentPageName = db$.getValue().getIn(['route']).name;
            let trackAction = '';

            if (currentPageName === 'page::myTicketsOverview') {
                trackAction = 'Detail podaneho tiketu';
            } else if (currentPageName === 'page::savedTickets') {
                trackAction = 'Detail ulozeneho tiketu';
            }

            fireGAEvent(CURRENT_PAGE, trackAction);

            if (alias) {
                navigate(TICKET_DETAIL_ALIAS, { alias });
            } else {
                navigate(TICKET_DETAIL, { hash });
            }
        };
    }, []);
}

export default useTicketDetail;
